import { RouteConfig } from "vue-router";

import AdminUser from "../views/pages/admin/user.vue";
import Admin from "../views/pages/admin/admin.vue";
import Products from "../views/pages/admin/products.vue";
import Setting from "../views/pages/admin/setting.vue";
import AdminLayout from "../views/layouts/admin/qMaster.vue";
import Customers from "../views/pages/admin/customers.vue";
import AdminCustomerIds from "@/views/pages/admin/adminCustomerIds.vue";
import OrderHistory from "@/views/pages/admin-customer/orderHistory.vue";
import { ROLE_ADMIN, ROLE_ADMIN_CUSTOMER } from "@/common/constant";

const adminRouter: Array<RouteConfig> = [
  {
    path: "/admin",
    name: "admin",
    component: AdminLayout,
    redirect: "admin/default",
    meta: {
      allowRole: ["admin"],
    },
    children: [
      {
        path: "default",
        name: "admin.default",
        redirect: "admin",
      },
      {
        path: "users",
        name: "admin.users",
        component: AdminUser,
        meta: {
          pageTitle: "管理者管理 | 株式会社HORIKOSHI",
          title: "管理者管理",
          subTitle: "製品管理や代表取引先を管理するユーザーを登録します。",
          className: "Admin",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "admin",
        name: "admin.admin",
        component: Admin,
        meta: {
          pageTitle: "社内利用者ID | 株式会社HORIKOSHI",
          title: "社内利用者ID一覧",
          subTitle: "製品管理や代表取引先を管理するユーザーを登録します。",
          className: "Admin",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "products",
        name: "admin.products",
        component: Products,
        meta: {
          pageTitle: "得意先注文者ID | 株式会社HORIKOSHI",
          title: "掲載製品一覧",
          subTitle: "製品の追加は、基幹システム側で行ってください。",
          isShowImportTitle: true,
          className: "Products",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "admin-customers",
        name: "admin.admin-customers",
        component: AdminCustomerIds,
        meta: {
          pageTitle: "得意先・請求先一覧 | 株式会社HORIKOSHI",
          title: "得意先・請求先一覧",
          subTitle:
            "HORIKOSHI 公式購入サイトを利用できる得意先は、基幹システム側でメンテナスしてください。",
          isShowImportTitle: true,
          className: "AdminCustomer",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "order-histories",
        name: "admin.order-histories",
        component: OrderHistory,
        meta: {
          pageTitle: "注文履歴 | 株式会社HORIKOSHI",
          title: "注文履歴",
          // subTitle: "代表得意先の追加は、基幹システム側で行ってください。",
          isShowLastOrderTimeTitle: false,
          className: "Order",
          allowRole: [ROLE_ADMIN, ROLE_ADMIN_CUSTOMER],
        },
      },
      {
        path: "setting",
        name: "admin.setting",
        component: Setting,
        meta: {
          pageTitle: "各種設定 | 株式会社HORIKOSHI",
          title: "各種設定",
          subTitle: "",
          isShowImportTitle: true,
          className: "Setting",
          allowRole: [ROLE_ADMIN],
        },
      },
      {
        path: "customers",
        name: "admin.customers",
        component: Customers,
        meta: {
          pageTitle: "得意先注文者ID | 株式会社HORIKOSHI",
          title: "注文者ID一覧",
          subTitle:
            "当サービスから発注を行う注文者様のご登録をお願いいたします。",
          isShowImportTitle: true,
          className: "Customer",
          allowRole: [ROLE_ADMIN],
        },
      },
    ],
  },
];

export default adminRouter;
